var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcGradeOff = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic-grade-off_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 17,
  r: 17,
  fill: "#F3F4F8"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic-grade-off_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#B6BAC0",
  d: "M14.68 14.265v10.206h4.64V14.265c0-.6-.487-1.088-1.088-1.088h-2.464c-.6 0-1.088.487-1.088 1.088"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DADEE5",
  d: "M20.596 19.306v5.165h4.64v-5.165c0-.6-.488-1.088-1.088-1.088h-2.464c-.601 0-1.088.487-1.088 1.088"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B6BAC0",
  d: "M8 25.235c0 .422.342.765.765.765h16.47a.765.765 0 0 0 0-1.53H8.765a.765.765 0 0 0-.765.765"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DADEE5",
  d: "M8.765 9.088v15.383h4.64V9.088c0-.6-.488-1.088-1.089-1.088H9.853c-.601 0-1.088.487-1.088 1.088"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-grade-off_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h34v34H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-grade-off_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M26 8H8v18h18z"
})))));
export default SvgIcGradeOff;